import { CommonGet, CommonPost, CommonGetIDServer } from "../../../utils/CommonFetch";

export default {
    getGroups,
    getEstatesByGroupID,
    getDivisions,
    getFields,
    getAllGangByFilter,
    saveGang,
    editGang
};
async function saveGang(data) {
    const formData = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        fieldID:parseInt(data.fieldID),
        collectionPointID: parseInt(data.collectionPointID),
        gangName:data.gangName,
        gangCode:data.gangCode,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        isActive: data.isActive
    }
    var result = await CommonPost('/api/Gang/SaveGang', null, formData);

    return result;
}
async function editGang(data) {
    const formData = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        fieldID : parseInt(data.fieldID),
        gangName:data.gangName.toString(),
        gangCode:data.gangCode,
        collectionPointID: parseInt(data.collectionPointID),
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString(),
        isActive: data.isActive,

    }
    var result = await CommonPost('/api/Gang/UpdateGang', null, formData);
    return result;
}
async function getFields(groupID, operationEntityID, collectionPointID) {
    var filterModel = {
        groupID: groupID.toString(),
        operationEntityID: operationEntityID.toString(),
        collectionPointID: collectionPointID.toString()
    }
    const response = await CommonPost('/api/Field/FilterFields', null, filterModel);
    let array = []
    for (let item of Object.entries(response.data)) {

        array[item[1]["fieldID"]] = item[1]["fieldName"]

    }
    return array;
}
async function getDivisions(estateID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateId=' + estateID);
    let array = []
    for (let item of Object.entries(response.data)) {

        array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]

    }
    return array;
}
async function getEstatesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupId=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        
    }
    return array;
}


async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}
async function getAllGangByFilter(operationEntityID,collectionPointID) {
    var response = await CommonGet('/api/Gang/GetGangBySearch', 'operationEntityID=' + operationEntityID  + '&collectionPointID='+ collectionPointID);
    return response.data;
}
